import React from 'react';

import PropTypes from 'prop-types';

import CurrencyColumn from '../../../components/columns/currency-column';
import { useGetAmountSummaryFromFulfillment } from '../../../fulfillment-plans/amount-summary/use-get-amount-summary-from-fulfillment';
import messages from '../../columns/messages';

const AmountPaidColumn = ({ fulfillmentId }) => {
  const amountSummary = useGetAmountSummaryFromFulfillment(fulfillmentId);
  if (!amountSummary?.totalPaid) {
    return '';
  }
  const { value, code } = amountSummary.totalPaid;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

AmountPaidColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const AmountPaid = {
  getMessageDescriptor: () => messages.amountPaid,
  id: 'amount-paid',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <AmountPaidColumn fulfillmentId={data.id} />;
  },
};
